/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MonthlyAchievementType } from './MonthlyAchievementType';
export type FromMonthlyAchievement = {
    type: FromMonthlyAchievement.type;
    achievementType: MonthlyAchievementType;
    rank: number;
};
export namespace FromMonthlyAchievement {
    export enum type {
        MONTHLY_ACHIEVEMENT = 'monthly_achievement',
    }
}

